import { SearchtoolboxService } from './_services/searchtoolbox.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router ,NavigationEnd  } from '@angular/router';
import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { LoginService } from './_services/login.service';
import { interval } from 'rxjs';
declare const clevertap;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ats-crm-frontend';
  signupForm: Boolean
  searchtoolScreen: Boolean
  userid :any
  totalGrabbedCandidate: any;
  routeCheckForScrollNavabar:boolean

  constructor(private location: Location ,private router: Router ,private localstorageservice:LocalStorageService,
    private loginService: LoginService ,private searchservice : SearchtoolboxService ) {
    
    //to check after every route change
    this.router.events.subscribe((xd) => { 
      if (xd instanceof NavigationEnd) { 
        if (location.path() == '/signup' || location.path() == '/login' || location.path() == '/feedback' || location.path() == '' || location.path().indexOf('login') > -1 
        || location.path().indexOf('resetpassword') > -1  || location.path().indexOf('forgetpassword') > -1 || location.path().indexOf('iframe-searchtoolbox') > -1 
        || router.url.includes('signup') || router.url.includes('teaminvite') || router.url.includes('expiry')) {
          this.signupForm = true
        } else {
          this.signupForm = false
        }
        if(location.path() == '/searchtoolbox-v2'){
          this.searchtoolScreen = true
        }else{
          this.searchtoolScreen = false
        }
        this.checkGrabStatus()
        this.sendMessagetoChrome()
        if(router.url.includes('signup') || router.url.includes('login')){
          document.getElementById('warning-message').classList.add('d-none')
          document.getElementById('wrapper').classList.add('d-block')
        }else{
          document.getElementById('warning-message').classList.remove('d-none')
          document.getElementById('wrapper').classList.remove('d-block')
        }
        if(this.router.url.includes('person/search/listing')){
          this.routeCheckForScrollNavabar=true
        }else{
          this.routeCheckForScrollNavabar=false
        }
      }
    });
  }

  loadApplication: boolean = false;

  ngAfterViewInit(){
    setTimeout(()=>{
      this.sendMessagetoChrome()
    },1000)
  }

  ngOnInit(): void {
    // on the fly token
    this.sendClevertapProfile()
    let token = sessionStorage.getItem('token');
    let emit = sessionStorage.getItem('emit');
    if (!token || !emit) {
      let data = { agent: window.navigator.userAgent };
      this.loginService.ontheflytoken(data)
      .subscribe((res: any) => {
       if (res.message && res.message.token) {
        // save token in local storage
        sessionStorage.setItem('token', res.message.token);
  
        // save current time in local storage
        sessionStorage.setItem('emit', `${+new Date()}`);

        // complete getting response from api then load the application
        this.loadApplication = true;
       } else {
        console.log('Something went wrong');
        this.loadApplication = true;
       }
      });
    } else {
      this.loadApplication = true;
    }
    this.searchservice.getGrabCandidateData().subscribe((res: any) => {
        if(res.profileurlsarray && res.profileurlsarray.length){
          this.localstorageservice.setItem('totalgrabcandidate',res.profileurlsarray.length)
          this.checkGrabStatus()
        }
    })
  }

  checkGrabStatus() {
    if (this.localstorageservice.getItem('totalgrabcandidate') > 0) {
      this.totalGrabbedCandidate = this.localstorageservice.getItem('totalgrabcandidate')
      interval(30000).subscribe(x => {
        this.searchservice.bulkextractionstatus().subscribe((res: any) => {
          if (res.bulkextractioninprogress == false) {
            this.localstorageservice.setItem('totalgrabcandidate', 0)
            this.totalGrabbedCandidate = null
          }
        })
      });
    } else {
      this.localstorageservice.setItem('totalgrabcandidate', 0)
      this.totalGrabbedCandidate = null
    }
  }
  
  sendMessagetoChrome(){
    let chromeid = localStorage.getItem('extensionID');
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, {
          action: 'login',
          usernumber: this.localstorageservice.getItem('usernumber'),
          userid: this.localstorageservice.getItem('userid'),
          firstname: this.localstorageservice.getItem('ufname'),
          lastname: this.localstorageservice.getItem('ulname'),
          token: this.localstorageservice.getItem('token'),
          userdata: this.localstorageservice.getItem('userdata')
        });
      } catch (error) {
        console.error('Here is the error message', error);
      }
    }
  }

  sendClevertapProfile(){
    let userdata = this.localstorageservice.getItem('userdata');
    if(userdata){
      let phone = userdata.extn ? "+91"+userdata.extn : "";  
      let userprofile = {
        "Name": userdata.firstname + " " + userdata.lastname,
        "Email": userdata.loginemail,
        "Identity": userdata.userid,
        "Phone": phone,
        "usertype": null,
        "Plan": userdata.paymentplanid,
        "Company Name": userdata.company,
        "Designation": userdata.designation,
        "Basic contact enrichment credits": userdata.balancebasiccontactenrichmentcredits,
        "Bulk Grabbing Credits": userdata.balancebulkgrabbingcredits,
        "Contact enrichment credits": userdata.balancecontactenrichmentcredits,
        "JD Parsing Credit": userdata.balancejdparsingcredits,
        "Balance Smart Email Credits": userdata.balancesmartemailcredits,
        "Balance Talent Pipeline Credits": userdata.balancetalentpipelinecredits,
        "Pooled Balance Basic Contact Enrichment Credits": userdata.pooledbalancebasiccontactenrichmentcredits,
        "Pooled Balance Bulk Grabbing Credits": userdata.pooledbalancebulkgrabbingcredits,
        "Pooled Balance Contact Enrichment Credits": userdata.pooledbalancecontactenrichmentcredits,
        "Pooled Balance JD Parsing Credits": userdata.pooledbalancejdparsingcredits,
        "Pooled Balance Smart Email Credits": userdata.pooledbalancesmartemailcredits,
        "Pooled Balance Talent Pipeline Credits": userdata.pooledbalancetalentpipelinecredits,
        }     
      clevertap.onUserLogin.push({ "Site": userprofile });
    }
  }
}

